import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Reveal } from './Reveal';

export const AboutTeaser = () => (
    <section className="py-24 px-6" data-testid="about-teaser-section">
        <Reveal className="max-w-[640px] mx-auto text-center">
            <h2 className="font-serif font-normal text-[clamp(1.9rem,4vw,2.6rem)] text-ink leading-tight" data-testid="about-teaser-title">
                Conoce más <span className="italic text-roselight">sobre mí</span>
            </h2>
            <p className="mt-5 text-[#4A4744] font-light">
                Quiero que sepas quién va a estar a tu lado: mi historia, lo que el gimnasio y el kickboxing
                significan para mí, y por qué nace todo esto.
            </p>
            <Link
                to="/sobre-mi"
                data-testid="about-teaser-link"
                className="mt-8 inline-flex items-center gap-3 rounded-full border border-rose text-rose px-7 py-3.5 text-sm font-medium tracking-wide hover:bg-rose hover:text-paper active:scale-95 transition"
            >
                Te cuento mi historia <ArrowRight size={16} />
            </Link>
        </Reveal>
    </section>
);
